/*global angular, _*/

var bibContentManager = angular.module('bibContentManager', []);
bibContentManager.factory('bibContentManager', ['$q', 'settings', 'sriClient', '$location',
  function ($q, settings, sriClient, $location) {
    'use strict';
    var that = {};
    var hashCache = {};
    var isPreviewMode = $location.search().preview;
    var hashTimestamp = isPreviewMode ? '?t=' + Math.round(+new Date() / 1000) : '';

    /**
     * Search for all content required by a root (and all its descendants).
     * @param {string} href the root content item
     * @param {array} types types of content to look for
     * @param {string} q a query term
     * @return {promise}
     */
    that.getContentUnder = function (href, types, q, params) {
      var d = $q.defer();

      var searchParams = Object.assign({}, {
        expand: 'summary',
        types: _.compact(types).toString(),
        q: q
      }, params);
      // TODO verify &useCase=ZILL_NEXT_VERSION_SEARCH with dev-v47 and delete this comment :)

      sriClient.getList('/search', searchParams, {baseUrl: settings.apisAndUrls.searchApi, raw: true})
        .then(function (data) {
          console.log(data);
          d.resolve(data);
        }).catch(function (err) {
          d.reject(err);
        });

      return d.promise;
    };

    /**
     * Search for all content referenced by a root (and all its descendants). - FROM CONTENT-API
     * @param {string} href the root content item
     * @param {array} types types of content to look for
     * @param {string} q a query term
     * @return {promise}
     */
    that.getContentReferencedFromContentRoot = function (href, types, q) {
      var d = $q.defer();
      var contentHash = hashCache[href];
      var hashD = $q.defer();

      var params = {
        'referencedBy.root': href,
        expand: 'full',
        limit: 500,
        typeIn: _.compact(types).toString(),
        q: q
      };

      if (contentHash && !isPreviewMode) {
        hashD.resolve(contentHash);
      } else {
        sriClient.get(
          href + '/hash' + hashTimestamp,
          {},
          {
            baseUrl: settings.apisAndUrls.api
          }
        ).then(function (response) {
          hashD.resolve(response.hash);
        }).catch(function (err) {
          d.reject(err);
        });
      }

      hashD.promise.then(function (hash) {
        sriClient.getAll('/content', params, {baseUrl: settings.apisAndUrls.cachedApi, headers: {'VSKO-Resource-Hash': hash}})
          .then(function (data) {
            d.resolve(data);
          }).catch(function (err) {
            d.reject(err);
          });
      });

      return d.promise;
    };

    /**
     * Search for all content referenced by a root. - FROM CONTENT-API
     * @param {string} href the root content item
     * @param {array} types types of content to look for
     * @param {string} q a query term
     * @return {promise}
     */
    that.getContentReferencedFromContent = function (href, types, q) {
      var d = $q.defer();
      var contentHash = hashCache[href];
      var hashD = $q.defer();

      var params = {
        referencedBy: href,
        expand: 'full',
        limit: 500,
        typeIn: _.compact(types).toString(),
        q: q
      };

      if (contentHash && !isPreviewMode) {
        hashD.resolve(contentHash);
      } else {
        sriClient.get(
          href + '/hash' + hashTimestamp,
          {},
          {
            baseUrl: settings.apisAndUrls.api
          }
        ).then(function (response) {
          hashD.resolve(response.hash);
        }).catch(function (err) {
          d.reject(err);
        });
      }

      hashD.promise.then(function (hash) {
        sriClient.getAll('/content', params, {baseUrl: settings.apisAndUrls.cachedApi, headers: {'VSKO-Resource-Hash': hash}})
          .then(function (data) {
            d.resolve(data);
          }).catch(function (err) {
            d.reject(err);
          });
      });

      return d.promise;
    };

    /**
     * Search for all content required by a root (and all its descendants). - FROM CONTENT-API
     * @param {string} href the root content item
     * @param {array} types types of content to look for
     * @param {string} q a query term
     * @return {promise}
     */
    that.getContentRequiredFromContent = function (href, types, q) {
      var d = $q.defer();
      var contentHash = hashCache[href];
      var hashD = $q.defer();

      var params = {
        'requiredBy.root': href,
        expand: 'full',
        limit: 500,
        typeIn: _.compact(types).toString(),
        q: q
      };

      if (contentHash && !isPreviewMode) {
        hashD.resolve(contentHash);
      } else {
        sriClient.get(
          href + '/hash' + hashTimestamp,
          {},
          {
            baseUrl: settings.apisAndUrls.api
          }
        ).then(function (response) {
          hashD.resolve(response.hash);
        }).catch(function (err) {
          d.reject(err);
        });
      }

      hashD.promise.then(function (hash) {
        sriClient.getAll('/content', params, {baseUrl: settings.apisAndUrls.cachedApi})
          .then(function (data) {
            d.resolve(data);
          }).catch(function (err) {
            d.reject(err);
          });
      });

      return d.promise;
    };

    /**
     * Search for all content referenced by a root (and all its descendants).
     * @param {string} href the root content item
     * @param {array} types types of content to look for
     * @param {string} q a query term
     * @return {promise}
     */
    that.getContentReferenced = function (href, types, q) {
      var d = $q.defer();

      var params = {
        relatedToCurriculumContent: href,
        expand: 'summary',
        limit: 500,
        types: _.compact(types).toString(),
        highlight: false,
        q: q
      };

      sriClient.getAll('/search', params, {baseUrl: settings.apisAndUrls.searchApi, raw: true})
        .then(function (data) {
          d.resolve(data);
        }).catch(function (err) {
          d.reject(err);
        });

      return d.promise;
    };

    /**
     * Get a content item with all its descendants in a three
     * @param href Href of the content item
     * @return {promise}
     */
    that.getContent = function (href) {
      const allowedTypes = ['HORIZONTAL_RULE', 'SECTION', 'MUSIC', 'ATTACHEMENTS_GROUP', 'VIDEO', 'ATTACHMENT', 'PARAGRAPH', 'VIDEO_GROUP', 'ATTACHMENTS_GROUP', 'TERM', 'IMAGE', 'IMAGE_GROUP', 'REFERENCE', 'REFERENCE_GROUP', 'QUOTE', 'EXAMPLE', 'FOOTNOTE', 'SOURCE', 'UNSTRUCTURED_DOCUMENT'];
      var d = $q.defer();
      var hashD = $q.defer();
      var returnData = {};
      var contentData = {};
      var getData = [];
      var contentHash = hashCache[href];

      function getAttachements(item, hash) {
        var thumbnail = _.find(item.attachments, {type: 'THUMBNAIL'});
        if (thumbnail) {
          item.thumbnail = thumbnail;
          item.thumbnail.url = settings.apisAndUrls.cachedApi + thumbnail.href + '?' + hash;
        }

        var cover = _.find(item.attachments, {type: 'COVER_IMAGE'});
        if (cover) {
          item.cover = cover;
          item.cover.url = settings.apisAndUrls.cachedApi + cover.href + '?' + hash;
        }

        var icon = _.find(item.attachments, {type: 'ICON'});
        if (icon) {
          item.icon = icon;
          item.icon.url = settings.apisAndUrls.cachedApi + icon.href + '?' + hash;
        }

        var background = _.find(item.attachments, {type: 'BACKGROUND_IMAGE'});
        if (background) {
          item.background = background;
          item.background.url = settings.apisAndUrls.cachedApi + background.href + '?' + hash;
        }

        var illustration = _.find(item.attachments, {type: 'ILLUSTRATION'});
        if (illustration) {
          item.illustration = illustration;
          item.illustration.url = settings.apisAndUrls.cachedApi + illustration.href + '?' + hash;
        }
      }

      //create the tree.
      var doRecursive = function (content, hash) {
        if (content.$$relationsTo.length > 0) {
          content.contents = [];
          getAttachements(content, hash);
          content.$$relationsTo.filter(o => o.$$expanded.to.href != o.$$expanded.from.href).sort(function (a, b) { return parseFloat(a.$$expanded.readorder) - parseFloat(b.$$expanded.readorder); }).forEach(function (relation) {
            var parent;
            var item = contentData[relation.$$expanded.from.href.split('/')[relation.$$expanded.from.href.split('/').length - 1]];
            if (item) {
              getAttachements(item, hash);
              item.readorder = parseFloat(relation.$$expanded.readorder);
              if (item.$$relationsTo) {
                parent = _.clone(content);
                delete parent.contents;
                item.parent = parent;
                doRecursive(item);
              }
              if(item.tags && item.tags[0] === 'LINK') {
                if (!content.links) {
                  content.links = [];
                }
                const referenceRelations = item.$$relationsFrom.filter(relation => relation.$$expanded.relationtype === 'REFERENCES');

                console.log(item);
                if (referenceRelations.length > 0) {
                  let link = referenceRelations[0].$$expanded.to.href;
                  if (!link.startsWith('http')) {
                    link = 'http://' + link;
                  }
                  content.links.push({
                    title: item.title,
                    link: link
                  });
                }
              } else if(item.type === 'SOURCE') {
                if(!content.sources) {
                  content.sources = [];
                }
                content.sources.push(item);
              } else {
                content.contents.push(item);
              }

              // Shared attachments have type UNSTRUCTURED_DOCUMENT
              if(item.type === 'ATTACHMENT' || item.type === 'UNSTRUCTURED_DOCUMENT') {
                if(!returnData.attachmentsOfDocument) {
                  returnData.attachmentsOfDocument = [];
                }
                returnData.attachmentsOfDocument.push(item);
              }


            }
          });
          content.contents = content.contents.sort(function (a, b) { return parseFloat(a.readorder) - parseFloat(b.readorder); });
        }
      };

      if (contentHash && !isPreviewMode) {
        hashD.resolve(contentHash);
      } else {
        sriClient.get(
          href + '/hash' + hashTimestamp,
          {},
          {
            baseUrl: settings.apisAndUrls.api
          }
        ).then(function (response) {
          hashD.resolve(response.hash);
        }).catch(function (err) {
          d.reject(err);
        });
      }
      hashD.promise.then(function (hash) {
        getData.push(
          sriClient.get(
            href,
            {
              expand: 'full'
            },
            {
              baseUrl: settings.apisAndUrls.cachedApi,
              headers: {'VSKO-Resource-Hash': hash}
            }
          ).then(function (data) {
            returnData = data;
          })
        );

        var typeIn = '';
        if (allowedTypes) {
          typeIn = _.compact(allowedTypes).toString();
        }

        getData.push(
          sriClient.getAll(
            '/content',
            {
              expand: 'full',
              root: href,
              limit: 500,
              typeIn: typeIn
            },
            {
              baseUrl: settings.apisAndUrls.cachedApi,
              headers: {'VSKO-Resource-Hash': hash}
            }
          ).then(function (data) {
            contentData = {};
            data.forEach(function (dataItem) {
              contentData[dataItem.key] = dataItem;
            });
          }, function () {
            d.reject();
          })
        );

        $q.all(getData).then(function () {
          getAttachements(returnData, hash);
          doRecursive(returnData, hash);
          d.resolve(returnData);
        });

      });

      return d.promise;
    };

    return that;
  }
]);
module.exports = bibContentManager;



// WEBPACK FOOTER //
// ./web/js/module/bibContent-manager/bibContent-manager.js